import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import cn from 'classnames';
import { Chip, Divider, Typography, withStyles } from "@material-ui/core";
import { receive_appointmentsList, } from "../../../apis/redux/fetchActions";
import APIService from "../../../apis/amplify/APIService";
import SectionTitleContainer, { SectionTitle } from '../../../components/SectionTitleContainer';
import { errorBundaryHOC } from '../../../components/ErrorBoundary';
import Loading, { LoadingText, Progress } from '../../../components/Loading';
import { formatCurrency, formatDate } from "../../../util/formatters";
import { styles } from './styles';
import If from "../../../components/If";

class Index extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loadingAppointments: true,
        }
    }

    componentDidMount() {
        APIService.getAppointmentListHistory()
            .then(response => {
                response.sort((a, b) => {
                    return parseInt(a.title.split(" ")[2], 10) > parseInt(b.title.split(" ")[2], 10);
                });
                this.props.actions.receive_appointmentsList(response);
            })
            .finally(() => {
                this.setState({ loadingAppointments: false });
            })
    }

    componentWillUnmount() {
        this.props.actions.receive_appointmentsList([]);
    }

    render() {
        const { classes, appointments } = this.props;
        const { loadingAppointments } = this.state;

        return (
            <div style={{ marginBottom: '50px' }}>

                <SectionTitleContainer>
                    <SectionTitle>Appointment History</SectionTitle>
                </SectionTitleContainer>

                <div style={{ minHeight: '100px', backgroundColor: '#fafafa' }}>
                    <If as={Loading} condition={loadingAppointments} style={{ paddingTop: 30 }}>
                        <Progress/><LoadingText>Loading appointment history...</LoadingText>
                    </If>
                    {(!loadingAppointments && !appointments.length) ? (
                            <Typography className={classes.emptyTypography} style={{ marginTop: 0, paddingTop: 30 }}
                                        variant='subtitle1' align="center">
                                There's not appointment registered yet
                            </Typography>
                        )
                        :
                        (
                            <Fragment>
                                {
                                    appointments.map(item => (
                                        <div className={cn(classes.itemPaper, 'appointmentItem')} key={item.id}>
                                            <Typography variant='subtitle1'>
                                                {item.title.replace(/0+/, '')}
                                            </Typography>
                                            <div className={classes.infoContainer}>
                                                <div className="rowColBlock">
                                                    <div className={classes.badgeDiv}>
                                                        <div className={classes.badgeLabel}>
                                                            <span>Price: {formatCurrency(item.price)}</span>
                                                        </div>
                                                    </div>
                                                    <div className={classes.badgeDiv}>
                                                        <div className={classes.badgeLabel}>
                                                            <span>Scheduled for: {`${formatDate(item.schedule)}  ${item.hour_slot.replace(/\s/g, '')}`}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={classes.badgeDiv}>
                                                    <div className={classes.badgeLabel}
                                                         style={{color: '#74bd43'}}>
                                                        <span>Status: {item.status}</span>
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: '15px' }}>
                                                    {
                                                        item.devices_to_repair.split(',').map((device, i) => (
                                                                <Chip label={device} key={i}
                                                                      style={{ marginRight: '10px' }}/>
                                                            )
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </Fragment>
                        )}
                </div>
                <Divider variant='fullWidth'/>
            </div>
        )
    }

}


const mapStateToProps = (state) => {
    return {
        appointments: state.appointmentsList
    }
};
const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({
            receive_appointmentsList: receive_appointmentsList,
        }, dispatch)
    }
};

const AppointmentHistoryContentStyled = withStyles(styles)(Index);
export default connect(mapStateToProps, mapDispatchToProps)(errorBundaryHOC(AppointmentHistoryContentStyled));
